import 'bootstrap/dist/css/bootstrap.min.css';
import React, { useCallback, useContext, useEffect, useState } from 'react';
import { Accordion, Alert, Badge, Button, ButtonGroup, CloseButton, Col, Container, FloatingLabel, Form, Image, InputGroup, Modal, ModalBody, ProgressBar, Row, Spinner, Tab, Tabs, Toast, ToggleButton } from 'react-bootstrap';
import * as Icon from 'react-bootstrap-icons';
import * as RIcon from "react-icons/fa"
import { LinkContainer } from 'react-router-bootstrap';
import { useNavigate } from 'react-router-dom';
import { LoginInfo } from '../../App';
import ImageFile from '../../domain/ImageFile';
import * as ImageUtil from '../../service/ImageUtil';
import ApiFetch from '../ApiFetch';
import CampaignMessage from '../CampaignMessage';
import Dialog from '../Dialog';
import Footer from '../Footer';
import Header from '../Header';
import Category from '../Category';
import EXIF from 'exif-js';
import extractChunks from 'png-chunks-extract/index'
import { Link } from 'react-router-dom';
import { useTranslation } from "react-i18next";
import  {  Typeahead  }  from  'react-bootstrap-typeahead' ;
import  'react-bootstrap-typeahead/css/Typeahead.css' ;
import Cropper from 'react-easy-crop'
import {getStyleList,setStyle,deleteStyleList} from '../../service/AIGenerateService';
import Questionnaire from '../Questionnaire';
import RegistOrLogin from '../RegistOrLogin';
import AITalk from '../AITalk';
import { Bar } from 'react-chartjs-2';

const UploadEvent = (props) => {
    function getAIGeneraleImageList(userId,page){
        return new ApiFetch().get(ApiFetch.API_PROTOCOL+"//"+ApiFetch.API_HOST+"/v1/image/generated/"+userId+"/"+page).then((r)=>r.json().then((json)=>{
            return json
        }))
    }
    function getStatusCount(){
        return new ApiFetch().get(ApiFetch.API_PROTOCOL+"//"+ApiFetch.API_HOST+"/v1/sd/statusCount").then((r)=>{
            return r.json()
        })
    }
    function getStatus(procId){
        return new ApiFetch().get(ApiFetch.API_PROTOCOL+"//"+ApiFetch.API_HOST+"/v1/sd/status/"+procId).then((r)=>{
            return r.json()
        })
    }
    function getPoint(){
        return new ApiFetch().get(ApiFetch.API_PROTOCOL+"//"+ApiFetch.API_HOST+"/v1/point").then((r)=>{
            return r.json()
        })
    }
    function getOdai(){
        return new ApiFetch().get(ApiFetch.API_PROTOCOL+"//"+ApiFetch.API_HOST+"/v1/odai/latest").then((r)=>r.json().then((json)=>{
            return json
        }))
    }
    function calcPoint(postCount){
        return new ApiFetch().get(ApiFetch.API_PROTOCOL+"//"+ApiFetch.API_HOST+"/v1/point/calc/"+postCount).then((r)=>{
            return r.json()
        })
    }
    function getSeriesList(userId){
        return new ApiFetch().get(ApiFetch.API_PROTOCOL+"//"+ApiFetch.API_HOST+"/v1/series/list/"+userId).then((r)=>r.json().then((json)=>{
            return json
        }))
    }
    function getUsersByDay(){
        return new ApiFetch().get(ApiFetch.API_PROTOCOL+"//"+ApiFetch.API_HOST+"/v1/sd/users").then((r)=>{
            return r.json()
        })
    }
    function tagSearch(word){
        return new ApiFetch().post(ApiFetch.API_PROTOCOL+"//"+ApiFetch.API_HOST+"/v1/tag/search/",{word:word}).then((r)=>r.json().then((json)=>{
            return json
        }))
    }
    async function getTagLatest(){
        return await new ApiFetch().get(ApiFetch.API_PROTOCOL+"//"+ApiFetch.API_HOST+"/v1/tag/latest/event").then((r)=>r.json().then((json)=>{
            return json
        }))
    }
    const {t,i18n} = useTranslation()
    // ログイン情報
    const {loginInfo,setLoginInfo} = useContext(LoginInfo)
    // ナビゲーション
    const navigate = useNavigate();

    // 最新タグ
    const [tagLatest,setTagLatest] = useState([])

    useEffect(() => {
        // お題
        getOdai().then(r => {
            if(r.result && r.data.length > 0){
                setOdai(r.data[0].odai)
            }
        })
        // 最新タグ
        getTagLatest().then(r => {
            if(r.result){
                setTagLatest(r.data)
            }
        })
    },[])

    // お題
    const [odai,setOdai] = useState([])
    const [useOdai,setUseOdai] = useState(false)

    // フラグ
    const [batchMode,setBatchMode] = useState(false)
    const [useFilename,setUseFilename] = useState(false)
    const [notReadPromptInfo,setNotReadPromptInfo] = useState(false)
    const [promptInfoPublication,setPromptInfoPublication] = useState(true)

    // アップロード処理
    const [batchUploading,setBatchUploading] = useState(false)
    const [batchProgressNow,setBatchProgressNow] = useState(0)
    const [batchProgressLabel,setBatchProgressLabel] = useState(0)
    const [uploading,setUploading] = useState(false)
    const [progressNow,setProgressNow] = useState(0)
    const [progressLabel,setProgressLabel] = useState(0)
    const maxFileSize = 31457280000
    // 104857600 100MB
    // 262144000 200MB
    // 31457280000 30GB

    // AIでの生成関連
    const [aiGenerateImageList,setAIGenerateImageList] = useState([]) // AI生成履歴
    const [aiGenerateImagePage,setAIGenerateImagePage] = useState(-1) // AI生成履歴パネルのページ
    const [aiGenerateReset,setAIGenerateReset] = useState(false) // AI生成履歴を再取得するためのフラグ

    let procId = ""
    useEffect(() => {
        if(aiGenerateImagePage > 0){
            getAIGeneraleImageList(loginInfo.userId,aiGenerateImagePage).then(r => {
                if(r.result){
                    if(r.data.length > 0){
                        if(aiGenerateImagePage === 1){
                            setAIGenerateImageList([].concat(r.data))
                        } else {
                            setAIGenerateImageList(aiGenerateImageList.concat(r.data))
                        }
                    } else {
                        if(aiGenerateImagePage === 1){
                            setAIGenerateImageList([])
                            //dialog("","履歴がありません。AI生成機能を利用してみませんか？")
                        }
                    }
                } else {
                    setAIGenerateImageList([])
                    dialog("確認",r.errors)
                }
            })
        }
    },[aiGenerateImagePage,aiGenerateReset])

    // 画像遅延ロード
    useEffect(() => {
        document.querySelectorAll(".lazy").forEach(e => observer.observe(e))
    },[aiGenerateImageList])

    // 投稿遅延ロード
    const options = {
        root: null,
        rootMargin: "500px",
        threshold: 0.05
    }
    const observer = new IntersectionObserver((entries,observer)=>{
        entries.forEach(entry => {
            if(entry.intersectionRatio > 0){
                const imgEl = entry.target;
                //imgEl.src = imgEl.dataset.src;          
                observer.unobserve(entry.target);
                // ロードした部分まで進んだら追加読み込み
                if(imgEl.dataset.no !== undefined && parseInt(imgEl.dataset.no) === (aiGenerateImagePage * 30 - 1) ){
                    setAIGenerateImagePage(aiGenerateImagePage+1)
                }
              }
        })
    }, options);

    // 編集情報
    const [editImageNo,setEditImageNo] = useState(-1)
    const [editImageTargetNo,setEditImageTargetNo] = useState(-1)
    const [editLabel,setEditLabel] = useState("モザイク描画")
    const [previewSource,setPreviewSource] = useState("")
    const [previewFlg,setPreviewFlg] = useState(false)
    const ref = React.createRef()
    const styleRef = React.createRef()
    const [styleOptions,setStyleOptions] = useState([])
    const [styleSelected,setStyleSelected] = useState([])
    const [generateMethodSelected,setGenearteMethodSelected] = useState([])
    const [optionSelected,setOptionSelected] = useState([])
    const [enterJpPrompt,setEnterJpPrompt] = useState(false)
    const [jpCost,setJpCost] = useState(0)
    const [aiTalkShow,setAiTalkShow] = useState(false)
    const [fromDate,setFromDate] = useState("")
    const [fromTime,setFromTime] = useState("")
    const [toDate,setToDate] = useState("")
    const [toTime,setToTime] = useState("")
    const [bookingDate,setBookingDate] = useState("")
    const [bookingTime,setBookingTime] = useState("")
    const [tagOptions, setTagOptions] = useState([])
    const [placeOptions, setPlaceOptions] = useState([{label:'海外',div:'abroad'},
    {label:'メタバース',div:'metaverse'},
    {label:'オンライン',div:'online'},
    {label:'北海道',div:'hokkaido'},
    {label:'青森県',div:'aomori'},
    {label:'岩手県',div:'iwate'},
    {label:'宮城県',div:'miyagi'},
    {label:'秋田県',div:'akita'},
    {label:'山形県',div:'yamagata'},
    {label:'福島県',div:'fukushima'},
    {label:'茨城県',div:'ibaraki'},
    {label:'栃木県',div:'tochigi'},
    {label:'群馬県',div:'gunma'},
    {label:'埼玉県',div:'saitama'},
    {label:'千葉県',div:'chiba'},
    {label:'東京都',div:'tokyo'},
    {label:'神奈川県',div:'kanagawa'},
    {label:'新潟県',div:'niigata'},
    {label:'富山県',div:'toyama'},
    {label:'石川県',div:'ishikawa'},
    {label:'福井県',div:'fukui'},
    {label:'山梨県',div:'yamanashi'},
    {label:'長野県',div:'nagano'},
    {label:'岐阜県',div:'gifu'},
    {label:'静岡県',div:'shizuoka'},
    {label:'愛知県',div:'aichi'},
    {label:'三重県',div:'mie'},
    {label:'滋賀県',div:'shiga'},
    {label:'京都府',div:'kyoto'},
    {label:'大阪府',div:'osaka'},
    {label:'兵庫県',div:'hyogo'},
    {label:'奈良県',div:'nara'},
    {label:'和歌山県',div:'wakayama'},
    {label:'鳥取県',div:'tottori'},
    {label:'島根県',div:'shimane'},
    {label:'岡山県',div:'okayama'},
    {label:'広島県',div:'hiroshima'},
    {label:'山口県',div:'yamaguchi'},
    {label:'徳島県',div:'tokushima'},
    {label:'香川県',div:'kagawa'},
    {label:'愛媛県',div:'ehime'},
    {label:'高知県',div:'kochi'},
    {label:'福岡県',div:'fukuoka'},
    {label:'佐賀県',div:'saga'},
    {label:'長崎県',div:'nagasaki'},
    {label:'熊本県',div:'kumamoto'},
    {label:'大分県',div:'oita'},
    {label:'宮崎県',div:'miyazaki'},
    {label:'鹿児島県',div:'kagoshima'},
    {label:'沖縄県',div:'okinawa'},])
    const [tag, setTag] = useState([])
    const [place, setPlace] = useState([])

    // 投稿完了後
    const [postedGroupId,setPostedGroupId] = useState("")
    const [url,setURL] = useState("")
    const [imgUrl,setImgURL] = useState("")
    let timer
    let uploadProgressNo = 0
    let oldUploadProgressNo = 1

    function uploadSelect(files){
        // アップロード開始
        setUploading(true)
        // 入力フォーム無効化
        setDisabled()
        upload(files)
    }

    /**
     * 入力フォームを無効化する
     */
    function setDisabled(){
        let elements = ["batch","title","description","original","limited-publication",
            "ai-model","prompt","negative-prompt","delete-password"
            ,"noise","steps","scale","seed","sampler","strength","mask-blur",
            "clip-skip","controlnet-enabled","controlnet-module","controlnet-model","controlnet-weight",
            "ensd","hires-upscale","hires-upscaler"
        ]
        elements.forEach(id => {
            if(loginInfo.result && id === "delete-password") return
            let elm = document.getElementById(id)
            if(elm !== null)
            elm.setAttribute("disabled",true)
        })
    }

    /**
     * 入力フォームの無効化を解除する
     */
    function unsetDisabled(){
        let elements = ["batch","title","description","original","limited-publication",
            "ai-model","prompt","negative-prompt","delete-password"
            ,"noise","steps","scale","seed","sampler","strength","mask-blur",
            "clip-skip","controlnet-enabled","controlnet-module","controlnet-model","controlnet-weight",
            "ensd","hires-upscale","hires-upscaler"
        ]
        elements.forEach(id => {
            if(loginInfo.result && id === "delete-password") return
            let elm = document.getElementById(id)
            if(elm !== null)
            elm.removeAttribute("disabled")
            
        })
    }

    function createDateTime(date,time){
        let datetime = ""
        if(date.length > 0 && time.length > 0){
            datetime = date + " " + time
        } else if(date.length > 0) {
            datetime = date + " " + "00:00"
        } else {
            datetime = ""
        }
        return datetime
    }

    function upload(files){
        let fd = new FormData()

        let bookingDatetime = createDateTime(bookingDate,bookingTime)
        let fromDatetime = createDateTime(fromDate,fromTime)
        let toDatetime = createDateTime(toDate,toTime)

        fd.append("title",document.getElementById("title").value)
        fd.append("fromDatetime",fromDatetime)
        fd.append("toDatetime",toDatetime)
        fd.append("eventTag",document.getElementById("event-tag").value)
        fd.append("bookingDatetime",bookingDatetime)
        fd.append("limitedPublication",optionSelected.findIndex(v => v.value === "limitedPublication") !== -1 ? "1" : "0")
        fd.append("displayNewList",optionSelected.findIndex(v => v.value === "newPostHidden") !== -1 ? "1" : "0")
        fd.append("displayRanking",optionSelected.findIndex(v => v.value === "rankingHidden") !== -1 ? "1" : "0")
        fd.append("editImageNo",editImageNo) // 標準サムネイル番号
        fd.append("seriesId",series.id !== undefined ? series.id : "") // シリーズID
        fd.append("insideThumbnail",insideThumbnail !== undefined ? insideThumbnail : "")
        fd.append("outsideThumbnail",outsideThumbnail !== undefined ? outsideThumbnail : "")
        if(questionInfo !== undefined){
            if(questionInfo.options.filter(v => v.length > 0).length > 0){
                fd.append("questionDeadlineDatetime",questionInfo.deadlineDate + " " + questionInfo.deadlineTime)
                questionInfo.options.filter(v => v.length > 0).forEach(d => {
                    fd.append("questionOptions[]",d)
                })
            }
        }
        // 開催地域
        place.map(d => d.label).forEach(d => {
            fd.append("placeDiv[]","#"+d)
        })
        fd.append("place",document.getElementById("place").value)
        fd.append("price",document.getElementById("price").value)
        fd.append("access",document.getElementById("access").value)
        fd.append("url",document.getElementById("url").value)
        fd.append("contact",document.getElementById("contact").value)
        fd.append("request",document.getElementById("request").value)
        let description = document.getElementById("description").value

        // タグ
        if(tag.length > 0){
            description += "\n" + tag.map(d => "#"+d).join(" ")
        }

        for(let i = 0;i < files.length;i++){
            let useMosaic = files[i].useMosaic
            let imageDataOriginal = files[i].imageDataOriginal
            fd.append("useMosaic[]",useMosaic ? "1" : "0")
            fd.append("imageDataOriginal[]",useMosaic ? base64ToFile(imageDataOriginal.replace(/^.*,/, ''),files[i].file.name) : "")
        }
        fd.append("description",description)
        for(let i = 0;i < files.length;i++){
            fd.append("file[]",files[i].useMosaic === "1" ? base64ToFile(files[i].imageDataEdited.replace(/^.*,/, ''),files[i].file.name) : files[i].file)
        }
        let req = new XMLHttpRequest()
        req.open("POST",ApiFetch.API_PROTOCOL+"//"+ApiFetch.API_HOST+"/v1/upload/event")
        req.withCredentials = true
        req.onreadystatechange = () => {
            if(req.readyState === 4 && req.status === 200){
                if(req.responseText !== ""){
                    var r = JSON.parse(req.responseText)
                    if(r.result){
                        let title = document.getElementById("title")
                        let titleValue = title.value

                        // 予約投稿でなければリンク共有メッセージを出す
                        if(bookingDate === ""){
                            // 投稿ID
                            setPostedGroupId(r.groupId)
                            // タグ
                            let tags = r.tags.filter(tag => {
                                // 自動で追加するタグは除外する
                                return tag !== "AIイラスト"
                            }).map(tag => "#" + tag).join(" ")
                            // サムネイルURL
                            setImgURL(ApiFetch.API_PROTOCOL+"//"+ApiFetch.IMG_HOST+r.img)
                            // ツイートURL
                            setURL("https://twitter.com/intent/tweet?ref_src=twsrc%5Etfw%7Ctwcamp%5Ebuttonembed%7Ctwterm%5Emention%7Ctwgr%5Eourt_official&text="
                                + encodeURIComponent("「アワートAI」AIイラスト無料生成&投稿サイトに投稿しました！\nイベント告知：「" + titleValue + "」\n" + ApiFetch.API_PROTOCOL+"//ourt-ai.work/event/"+r.groupId + "\n#アワートAI #イベント")
                            )
                        } else {
                            dialog("確認","予約投稿が完了しました。")
                        }
                        // 入力内容をリセット
                        setFileList([])
                        unsetDisabled()
                        // アップロード終了
                        setUploading(false)
                        uploadProgressNo++
                    } else {
                        clearInterval(timer)
                        unsetDisabled()
                        setBatchProgressNow(0)
                        setBatchProgressLabel(0)
                        setBatchUploading(false)
                        setUploading(false)
                        dialog("エラー",r.errors.join("\r\n"))
                    }
                    setTempThumbnail()
                    setProgressNow(0)
                    setProgressLabel(0)
                }
            }
        }
        req.onerror = () => {
            clearInterval(timer)
            setUploading(false)
            unsetDisabled()
            setProgressNow(0)
            setProgressLabel(0)
            setBatchProgressNow(0)
            setBatchProgressLabel(0)
            setBatchUploading(false)
            setUploading(false)
            dialog("エラー","通信エラーが発生しました。")
        }
        req.upload.onprogress = (e) => {
            let per = Math.floor(e.loaded / e.total * 100)
            let label = ""
            if(per === 100){
                label = "登録中"
            } else {
                label = per + "%"
            }
            setProgressNow(per)
            setProgressLabel(label)
        }
        req.send(fd)
    }

    // 画像設定
    const [fileList, setFileList] = useState([])
    const [fileSize, setFileSize] = useState(0)
    const [fileSizeByte, setFileSizeByte] = useState(0)
    const [fileSizeOver,setFileSizeOver] = useState(false)

    useEffect(() => {
        if(loginInfo.result === false){
            //navigate("/")
        }
        if(loginInfo.result && loginInfo.status !== 0){
            dialog(t("common.error"),"アカウントは利用できません。")
        }
        if(loginInfo.result){
            // シリーズ
            getSeriesList(loginInfo.userId).then(r => {
                if(r.result){
                    let list = []
                    for(let i = 0;i < r.data.length;i++){
                        list.push({"label":r.data[i].info.series_name,"id":r.data[i].info.series_id})
                    }
                    setSeriesList(list)
                }
            })
        }
    },[loginInfo])

    useEffect(() => {
        // タイトル設定
        document.querySelector("title").textContent = "イベント情報の投稿 - アワートAI"

        // ファイルサイズ合計計算
        let size = 0
        for(let i = 0;i < fileList.length;i++){
            size += fileList[i].file.size
        }
        setFileSizeByte(size)
        size = size / 1024 / 1024 / 1024
        setFileSizeOver(size > 300)
        setFileSize(Math.ceil(size) + " GB")


        if(fileList.length > 0){
            document.getElementById("load-image").src = fileList[editImageNo].useMosaic ? fileList[editImageNo].imageDataEdited : fileList[editImageNo].imageDataMiddle
            if(selectedImageFilename !== fileList[editImageNo].file.name){
                //setInsideThumbnail()
                //setOutsideThumbnail()
                setSelectedImageFilename(fileList[editImageNo].file.name)
            }
            if(tempThumbnail === undefined){
                ImageUtil.load(fileList,fileList[0].file,0,(data,data2,data3)=>{
                    if(data !== false){
                        setInsideThumbnail(data3)
                    }
                })
            }
        }
    },[fileList])

    // 調整用サムネイル
    const [insideThumbnail,setInsideThumbnail] = useState()   // 内部用
    const [outsideThumbnail,setOutsideThumbnail] = useState() // 外部用(OGP)
    const [tempThumbnail,setTempThumbnail] = useState()
    const [selectedImageFilename,setSelectedImageFilename] = useState()

    useEffect(() => {
        if(fileList.length > 0){
            document.getElementById("load-image").src = fileList[editImageNo].useMosaic ? fileList[editImageNo].imageDataEdited : fileList[editImageNo].imageDataMiddle
            //setInsideThumbnail()
            //setOutsideThumbnail()
            setSelectedImageFilename(fileList[editImageNo].file.name)
        }
    },[editImageNo])

    // 編集対象の画像を処理
    useEffect(() => {
        if(editImageTargetNo !== -1){
            let file = fileList[editImageTargetNo]
            setCanvas(file)
        }
    },[editImageTargetNo])

    function imageSet(files){
        setMessage('')
        setMessageShow("none")
        let fileList = []
        for(let i = 0;i < files.length;i++){
            let img = new ImageFile({file:files[i]})
            fileList.push(img)
        }
        setEditImageNo(0)
        setFileList(fileList)
    }

    function imageAdd(files){
        setMessage('')
        setMessageShow("none")
        let list = fileList.concat([])
        for(let i = 0;i < files.length;i++){            
            let img = new ImageFile({file:files[i]})
            list.push(img)
        }
        setFileList(list)
    }

    // ダイアログ
    const [show, setShow] = useState(false)
    const [dialogTitle, setDialogTitle] = useState("")
    const [dialogMessage, setDialogMessage] = useState("")
    const [dialogButton,setDialogButton] = useState()
    function dialog(title,message,button){
        setDialogTitle(title)
        setDialogMessage(message)
        setShow(true)
        setDialogButton(button)
    }

    // エラーメッセージ
    const [message, setMessage] = useState('')
    const [messageShow, setMessageShow] = useState('none')

    function base64ToFile(base64,filename){
        let bin = atob(base64.replace(/^.*,/, ''));
        let buffer = new Uint8Array(bin.length);
        for (let i = 0; i < bin.length; i++) {
            buffer[i] = bin.charCodeAt(i);
        }
        return new File([buffer.buffer], filename, {type: "image/png"});
    }
    function clearAllInterval(){
        for (var i = 1; i < 99999; i++)
            window.clearInterval(i)
    }
    function setCanvas(file){
        let data = file.useMosaic === "1" ? file.imageDataEdited : file.imageDataOriginal
        let canvas = document.createElement("canvas")
        canvas.id = "canvas"
        let ctx = canvas.getContext("2d")

        let img = document.createElement("img")
        img.src = data
        img.onload = () => {
            let w = 0
            let h = 0
            if(img.naturalWidth > img.naturalHeight){
                w = window.innerWidth
                h = img.naturalHeight * (window.innerWidth / img.naturalWidth)
            } else {
                w = img.naturalWidth * ((window.innerHeight - 110) / img.naturalHeight)
                h = window.innerHeight - 110
            }
            w = img.naturalWidth
            h = img.naturalHeight
            canvas.width = w
            canvas.height = h
            //canvas.style.border = "5px solid #FFFFFF"
            canvas.style.zIndex = "5"
            canvas.style.margin = "0"
            canvas.style.padding = "0"
            canvas.onmouseup = (e) => canvasMouseUp(e)
            canvas.onmousedown = (e) => canvasMouseDown(e)
            canvas.onmousemove = (e) => canvasMouseMove(e)

            ctx.drawImage(img,0,0,img.naturalWidth,img.naturalHeight,0,0,w,h)
            document.getElementById("canvas-area").textContent = ""
            document.getElementById("canvas-area").append(canvas)

            if(file.useMosaic === "1"){
                let originalImage = document.createElement("img")
                originalImage.src = file.imageDataOriginal
                originalImage.onload = () => {
                    setOriginalImage(originalImage)
                }
            } else {
                setOriginalImage(img)
            }
            setMosaicImage()
        }
        return true
    }
    function setMosaicImage(){
        let originalImage = getOriginalImage()
        let ctx = originalImage.getContext("2d")

        let mosaicCanvas = document.getElementById("mosaic-image")
        mosaicCanvas.width = originalImage.width
        mosaicCanvas.height = originalImage.height
        let mosaicCtx = mosaicCanvas.getContext("2d")

        let imgData = ctx.getImageData(0, 0, originalImage.width, originalImage.height)
        if (imgData !== "") {
            if(getMosaicStyle() === "dot"){
                let mosaicSize = parseInt(getMosaicStrength(), 10)
                for (let y = 0; y < imgData.height; y+=mosaicSize) {
                    for (let x = 0; x < imgData.width; x+=mosaicSize) {
                        let cR = imgData.data[(y * imgData.width + x) * 4]
                        let cG = imgData.data[(y * imgData.width + x) * 4 + 1]
                        let cB = imgData.data[(y * imgData.width + x) * 4 + 2]
                        mosaicCtx.fillStyle = "rgb("+cR+","+cG+","+cB+")"
                        mosaicCtx.fillRect(x,y,x + mosaicSize,y + mosaicSize)
                    }
                }
            } else if(getMosaicStyle() === "blur"){
                let tempImg = document.createElement("canvas")
                tempImg.width = originalImage.width
                tempImg.height = originalImage.height
                let imageData = ctx.getImageData(0,0,originalImage.width,originalImage.height)
                let tempCtx = tempImg.getContext("2d")
                tempCtx.putImageData(imageData,0,0)

                mosaicCtx.filter = "blur(" + getMosaicStrength() + "px)"
                mosaicCtx.drawImage(tempImg,0,0)
            }
        }
    }
    function mosaicCanvas(){
        setImageEditFlag(1)
        let drawCanvas = document.getElementById("canvas")
        let ctx = drawCanvas.getContext("2d")

        let mosaicCanvas = document.getElementById("mosaic-image")
        let mosaicCtx = mosaicCanvas.getContext("2d")

        let mosaicImgData = mosaicCtx.getImageData(0, 0, drawCanvas.width, drawCanvas.height)
        ctx.putImageData(mosaicImgData,0, 0)
    }
    function getMosaicImage() {
        return document.getElementById("mosaic-image")
    }
    let mousePress = false
    function canvasMouseUp(e) {
        mousePress = false
    }
    function canvasMouseDown(e) {
        mousePress = true
        canvasMouseMove(e)
    }
    function setDrawFlag(flag){
        let canvasArea = document.getElementById("canvas-area")
        canvasArea.dataset.selectdrawflag = flag
    }
    function getDrawFlag(){
        let canvasArea = document.getElementById("canvas-area")
        return canvasArea.dataset.selectdrawflag
    }
    function setOriginalImage(img){
        let original = document.getElementById("original-image")
        original.width = img.naturalWidth
        original.height = img.naturalHeight
        let originalCtx = original.getContext("2d")
        // console.log(img.naturalWidth,img.naturalHeight)
        originalCtx.drawImage(img,0,0,img.naturalWidth,img.naturalHeight,0,0,img.naturalWidth,img.naturalHeight)
    }
    function getOriginalImage(){
        return document.getElementById("original-image")
    }
    function setMosaicSize(size){
        let canvasArea = document.getElementById("canvas-area")
        canvasArea.dataset.mosaicsize = size
    }
    function getMosaicSize(){
        let canvasArea = document.getElementById("canvas-area")
        return canvasArea.dataset.mosaicsize
    }
    function setMosaicStrength(strength){
        let canvasArea = document.getElementById("canvas-area")
        canvasArea.dataset.mosaicstrength = strength
    }
    function getMosaicStrength(){
        let canvasArea = document.getElementById("canvas-area")
        return canvasArea.dataset.mosaicstrength
    }
    function setMosaicStyle(style){
        let canvasArea = document.getElementById("canvas-area")
        canvasArea.dataset.mosaicstyle = style
    }
    function getMosaicStyle(){
        let canvasArea = document.getElementById("canvas-area")
        return canvasArea.dataset.mosaicstyle
    }
    function canvasMouseMove(e) {
        if(!mousePress) return
        let drawFlag = getDrawFlag()
        let mosaicSize = getMosaicSize()
        // 描画モード
        if(drawFlag === "1"){
            setImageEditFlag(1)
            let client = e.currentTarget.getBoundingClientRect()
            // console.log(e.pageY,client.top,client.y,window.scrollY)
            let x = e.pageX - client.x - window.scrollX - mosaicSize / 2
            let y = e.pageY - client.y - window.scrollY - mosaicSize / 2

            let mosaicImageCtx = getMosaicImage().getContext("2d")
            let ctx = e.currentTarget.getContext("2d")

            let imageData = mosaicImageCtx.getImageData(x,y,mosaicSize,mosaicSize)
            ctx.putImageData(imageData,x,y)
        }
        // 消しゴムモード
        if(drawFlag === "2"){
            setImageEditFlag(1)
            let client = e.currentTarget.getBoundingClientRect()
            let x = e.pageX - client.x - mosaicSize / 2
            let y = e.pageY - client.y - mosaicSize / 1

            let ctx = e.currentTarget.getContext("2d")
            ctx.drawImage(getOriginalImage(),x,y,mosaicSize,mosaicSize,x,y,mosaicSize,mosaicSize)
        }
    }
    function resetCanvas() {
        setImageEditFlag(0)
        let canvas = document.getElementById("canvas")
        let ctx = canvas.getContext("2d")
        let img = document.createElement("img")
        img.src = fileList[editImageTargetNo].imageDataOriginal
        img.onload = () => {
            ctx.drawImage(img,0,0)
        }
    }
    // 変更内容を保存
    function saveEdit() {
        fileList[editImageTargetNo].useMosaic = getImageEditFlag()
        fileList[editImageTargetNo].imageDataEdited = document.getElementById("canvas").toDataURL("image/png")
        setFileList(fileList.concat())
        setEditImageTargetNo(-1)
    }
    // 保存せず閉じる
    function closeEdit() {
        setEditImageTargetNo(-1)
    }
    function setImageEditFlag(flag){
        let canvasArea = document.getElementById("canvas-area")
        canvasArea.dataset.imageeditflag = flag
    }
    function getImageEditFlag(){
        let canvasArea = document.getElementById("canvas-area")
        return canvasArea.dataset.imageeditflag
    }
    let costList = [
        {width:"512",height:"512",cost:5,stepsPer:1,stepsLimit:150},
        {width:"768",height:"768",cost:10,stepsPer:2,stepsLimit:150},
        {width:"1152",height:"1152",cost:35,stepsPer:7,stepsLimit:150},
        {width:"1536",height:"1536",cost:70,stepsPer:21,stepsLimit:150},

        {width:"512",height:"768",cost:7,stepsPer:1,stepsLimit:150},
        {width:"768",height:"1152",cost:15,stepsPer:5,stepsLimit:150},
        {width:"1024",height:"1536",cost:30,stepsPer:10,stepsLimit:150},

        {width:"768",height:"512",cost:7,stepsPer:1,stepsLimit:150},
        {width:"1152",height:"768",cost:15,stepsPer:5,stepsLimit:150},
        {width:"1536",height:"1024",cost:30,stepsPer:10,stepsLimit:150},

        {width:"1280",height:"720",cost:15,stepsPer:5,stepsLimit:150},
        {width:"1600",height:"900",cost:30,stepsPer:10,stepsLimit:150},
        {width:"1920",height:"1080",cost:45,stepsPer:15,stepsLimit:150},

        {width:"720",height:"1280",cost:15,stepsPer:5,stepsLimit:150},
        {width:"900",height:"1600",cost:30,stepsPer:10,stepsLimit:150},
        {width:"1080",height:"1920",cost:45,stepsPer:15,stepsLimit:150},
    ]

    const [dragElm,setDragElm] = useState()
    // noと距離x,y
    const [len,setLen] = useState([-1,0,0])
    // 範囲内に存在する
    const [inRange,setInRange] = useState(false)
    // 選択中のno
    const [selectingNo,setSelectingNo] = useState(0)
    function dragStart(e,i){
        //console.log("dragStart",e)
        setDragElm("imgDrag"+i)
        //let img = document.querySelector("#imgDrag"+i)
        //console.log(img)
        if(e.type !== "touchstart"){
            let img = document.getElementById("dummy")
            e.dataTransfer.setDragImage(img,75, 75)
        }
        //e.dataTransfer.effectAllowed = "none"
    }
    // DPM Adaptiveは永遠に終わらなかった
    //let samplers = [{"name":"Euler a","aliases":["k_euler_a","k_euler_ancestral"],"options":{}},{"name":"Euler","aliases":["k_euler"],"options":{}},{"name":"LMS","aliases":["k_lms"],"options":{}},{"name":"Heun","aliases":["k_heun"],"options":{}},{"name":"DPM2","aliases":["k_dpm_2"],"options":{"discard_next_to_last_sigma":"True"}},{"name":"DPM2 a","aliases":["k_dpm_2_a"],"options":{"discard_next_to_last_sigma":"True"}},{"name":"DPM++ 2S a","aliases":["k_dpmpp_2s_a"],"options":{}},{"name":"DPM++ 2M","aliases":["k_dpmpp_2m"],"options":{}},{"name":"DPM++ SDE","aliases":["k_dpmpp_sde"],"options":{}},{"name":"DPM fast","aliases":["k_dpm_fast"],"options":{}},{"name":"DPM adaptive","aliases":["k_dpm_ad"],"options":{}},{"name":"LMS Karras","aliases":["k_lms_ka"],"options":{"scheduler":"karras"}},{"name":"DPM2 Karras","aliases":["k_dpm_2_ka"],"options":{"scheduler":"karras","discard_next_to_last_sigma":"True"}},{"name":"DPM2 a Karras","aliases":["k_dpm_2_a_ka"],"options":{"scheduler":"karras","discard_next_to_last_sigma":"True"}},{"name":"DPM++ 2S a Karras","aliases":["k_dpmpp_2s_a_ka"],"options":{"scheduler":"karras"}},{"name":"DPM++ 2M Karras","aliases":["k_dpmpp_2m_ka"],"options":{"scheduler":"karras"}},{"name":"DPM++ SDE Karras","aliases":["k_dpmpp_sde_ka"],"options":{"scheduler":"karras"}},{"name":"DDIM","aliases":[],"options":{}},{"name":"PLMS","aliases":[],"options":{}}]
    let samplers = [{"name":"Euler a","memo":"やわらかい表現、速い"},{"name":"DPM++ 2M Karras","memo":"人気"},{"name":"DPM++ SDE Karras","memo":"人気"},{"name":"DDIM","memo":"通常の表現"},{"name":"PLMS","memo":"stepsは35以上を推奨。色が強くでる"},{"name":"UniPC","memo":"速い"}]
    function textareaSizing(labelElementId,elementId){
        let labelElement = document.querySelector(labelElementId)
        labelElement.style.lineHeight = "20px"
        let lineHeight = labelElement.style.lineHeight.replace(/[^0-9.]+/,'')
        let n = labelElement.value.match(/\n/g)
        if(n === null){
            n = 1
        } else {
            n = n.length + 1
        }
        if(n <= 5){
            n = 5
        }
        labelElement.style.height = lineHeight * n + 30 + "px"
        document.querySelector(elementId).style.height = lineHeight * n + 30 + "px"
    }

    // キャンバスのリサイズ
    const [canvasAreaHeight,setCanvasAreaHeight] = useState(window.innerHeight - 100)
    window.onresize = function () {
        setCanvasAreaHeight(window.innerHeight - 100)
    }
    const [crop, setCrop] = useState({ x: 0, y: 0 })
    const [zoom, setZoom] = useState(1)
    const [showCropper,setShowCropper] = useState()
    const [cropTarget,setCropTarget] = useState()
    const onCropComplete = useCallback((croppedArea, croppedAreaPixels) => {
            let image = document.getElementById("load-image")
            let canvas = document.createElement("canvas")
            let ctx = canvas.getContext("2d")
            canvas.width = image.width
            canvas.height = image.height

            ctx.drawImage(image,0,0)

            const data = ctx.getImageData(croppedAreaPixels.x,croppedAreaPixels.y,croppedAreaPixels.width,croppedAreaPixels.height)

            canvas.width = croppedAreaPixels.width
            canvas.height = croppedAreaPixels.height

            ctx.putImageData(data,0,0)

            let thumb = canvas.toDataURL("image/png")

            setTempThumbnail(thumb)
      }, [])
    const [showQuestionnairePopup,setShowQuestionnairePopup] = useState(false)
    const [questionInfo,setQuestionInfo] = useState()
    document.onpaste = function(pasteEvent) {
        let item = pasteEvent.clipboardData.items[0];
     
        if (item.type.indexOf("image") === 0){
            let file = item.getAsFile();
            if(fileList.length === 0){
                imageSet([file],setFileList)
            } else {
                imageAdd([file],fileList,setFileList)
            }
        }
    }
    // シリーズ
    const [seriesList,setSeriesList] = useState([])
    const [series,setSeries] = useState("")

    function displayAIGenerateInfo(){
        dialog("AI生成機能の説明",<div>
            AI生成機能ではプロンプトという文字列を入力して、画像を生成することができます。<br />
            無料で利用することができますが、生成にはポイントを使用し、ポイントは、
            活動実績に伴い翌日の基準ポイントが判定され、保有ポイントがその基準以下の場合に基準まで回復します。<br />
            この基準の判定と回復には登録から5日以上経過し、SMS認証をしている必要があります。<br />
            SMS認証は「設定」→「セキュリティ」タグから行えます<br />
            ※無料であるため、複数アカウントを作成し不正にポイントを消費することへの対策となりますのでご了承ください。<br /><br />
            また、これ以外にも画像を投稿することでポイントが少し付与されます。<br />
            不明点は<a href="https://discord.gg/vQNvaCXYvu">Discord</a>よりお問い合わせください。<br />
            <hr />
            ■ポイント回復基準<br />
            登録から5日以上経過し、SMS認証を行っていること。<br />
            <br />
            例：投稿数100 いいね数200<br />
            <br />
            条件1<br />
            ■前提<br />
            ・総利用ポイント2000毎に1枚の投稿があること。<br />
            ・1投稿に対して平均1いいね以上<br />
            <br />
            ■計算方法<br />
            　① 1000 * 投稿数の平均いいね数(1000以上の場合は1000)<br />
            　　例：1000 * 2 = 2000 → 1000<br />
            　② 投稿数が30枚以上の場合はさらに1000 * 投稿数の平均いいね数<br />
            　　例：1000 * 2 = 2000<br />
            　基準ポイントは①+②の3000<br />
            <br />
            条件1の前提を満たさない場合500ポイント<br />
            登録から5日以上経過していない場合は0ポイント <br /><br />
            ※条件は定期的に見直されます。<br />
            ➡総利用ポイント、翌日の基準ポイントは「マイページ」→「実績」から確認できます。<br />
            <hr />
            ・他の生成サービスの紹介<br />
            <a href="https://aiart-navi.com/aiart-ai/">(一部無料) えいあーとAI</a><br />
            <a href="https://holara.ai/" target={"_blank"} rel="noreferrer">(一部無料) Holara</a><br />
            <a href="https://novelai.net/" target={"_blank"} rel="noreferrer">(有料) NovelAI</a><br />
            <a href="https://note.com/ai_nios/n/n0826a33edc8a"  target={"_blank"} rel="noreferrer">(有料) Google Colabで画像生成AIの色々なモデルを簡単に使おう</a>
        </div>)
    }

    // AI生成機能の時間帯別利用件数
    const [userList,setUserList] = useState([])

    function createGraphData(r,title){
        const graphData = {
            labels: 
                // 軸ラベル
                // 各ラベルを配列にすることで軸ラベルが改行されて表示される
                r.map(d => [d.ymdh+"時"])
            ,
            datasets: [
                // 表示するデータセット
                {
                    data: r.map(d => d.count),
                    label: title
                },
            ],
        }
        return graphData
    }

    function uploadHandler(e){
        if(loginInfo.result === false){
            dialog(t("common.loginToContinue"),<RegistOrLogin dialog={dialog} />)
            return
        }
        let title = document.getElementById("title")
        let description = document.getElementById("description")
        if(title.value.trim().length === 0 ){
            dialog("エラー","タイトルを入力して下さい。")
            return false
        }
        if(description.value.trim().length === 0){
            dialog("エラー","概要を入力して下さい。")
            return false
        }
        if(bookingDate !== "" && bookingTime === ""){
            dialog("確認","予約投稿を行う場合は時分も入力してください。")
            return false
        }
        if(bookingDate === "" && bookingTime !== ""){
            dialog("確認","予約投稿を行う場合は年月日も入力してください。")
            return false
        }
        let request = document.getElementById("request")
        if(request.value.trim().length > 50000){
            dialog("エラー","機能追加要望等の上限は50,000文字です。")
            return false
        }
        // ファイルサイズチェック
        let fileSize = 0
        for(let i = 0;i < fileList.length;i++){
            fileSize += fileList[i].file.size
        }
        // 104857600 100MB
        // 262144000 200MB
        // 107374182400 100GB
        if(fileSize > 31457280000){
            dialog("エラー","ファイルサイズの合計は30GBです。")
            return
        }
        if(fileList.length === 0){
            dialog("エラー","ファイルを選択して下さい。")
            return false
        }
        // ファイル数チェック
        if(fileList.length > 200){
            dialog("エラー","一度にアップロードできるのは200ファイルまでです。")
            return false
        }
        if(insideThumbnail === undefined){
            dialog("エラー","サムネイルを設定してください。")
            return false
        }
        /*if(outsideThumbnail === undefined){
            dialog("エラー","外部サイト向けサムネイルを設定してください。")
            return false
        }*/
        uploadSelect(fileList)
    }

    return (
    <>
    <div style={{display:editImageTargetNo !== -1 ? "block" : "none",position:"fixed",top:0,width:"100%",height:"100%",background:"#000000",zIndex:4,opacity:"0.9"}}>
    </div>
    <div id="paint-tools" style={{display:editImageTargetNo !== -1 ? "block" : "none",position:"fixed",top:0,color:"#FFFFFF",margin:"0 auto",zIndex:4,width:"100%"}} className="text-center">
        <div style={{width:"100%"}} className="d-flex justify-content-center">
            <p style={{display:"block"}}>モザイクのスタイル：</p>
            <Form.Select id="mosaic-size" className="mb-1" style={{display:"block",width:"100px"}}
                onChange={(e) => {
                    setMosaicStyle(e.currentTarget.value)
                    setMosaicImage()
                }}>
                <option value="dot">ドット</option>
                <option value="blur">ぼかし</option>
            </Form.Select>
            <p style={{display:"block"}}>モザイクの大きさ：</p>
            <Form.Select id="mosaic-size" className="mb-1" style={{display:"block",width:"100px"}}
                onChange={(e) => {
                    setMosaicSize(e.currentTarget.value)
                }} defaultValue={30}>
                {[...Array(30)].map((v,i) => {
                    return <option value={(i+1)*2} key={i}>{(i+1)*2}px</option>
                })}
            </Form.Select>
            <p style={{display:"block"}}>モザイク強度：</p>
            <Form.Control type="number" id="mosaic-strength" min={1} className="mb-1" style={{display:"block",width:"100px"}}
                onChange={(e) => {
                    setMosaicStrength(e.currentTarget.value)
                    setMosaicImage()
                }} defaultValue={20}>
            </Form.Control>
        </div>
        <Button variant={editLabel === "mosaic" ? 'light' : "primary"} onClick={() => {
            setDrawFlag(1)
            setEditLabel("mosaic")
        }}><Icon.BrushFill /></Button>
        <Button variant={editLabel === "eraser" ? 'light' : "primary"} style={{marginLeft:"3px"}} onClick={() => {
            setDrawFlag(2)
            setEditLabel("eraser")
        }}><Icon.EraserFill /></Button>
        <Button variant='primary' style={{marginLeft:"3px"}} onClick={() => {
            mosaicCanvas()
        }}>全体をモザイク</Button>
        <Button variant='success' style={{marginLeft:"3px"}} onClick={() => {
            saveEdit()
        }}>OK</Button>
        <Button variant='danger' style={{marginLeft:"3px"}} onClick={() => {
            resetCanvas()
        }}>Reset</Button>
        <Button variant='danger' style={{marginLeft:"3px"}} onClick={() => {
            closeEdit()
        }}>Close</Button>
        <br />
        <canvas id="tempCanvas" style={{display:"none"}} />
        <div id="canvas-area" className="m-0 p-0" data-selectdrawflag={1} data-mosaicsize={30} data-mosaicstrength={20} data-imageeditflag={0} data-mosaicstyle={"dot"} 
            style={{width:"auto",height:canvasAreaHeight,overflow:"auto"}}
        />
        <canvas id="original-image" style={{display:"none"}} />
        <canvas id="mosaic-image" style={{display:"none"}} />
    </div>
    <div className="wrapper">
        <Dialog title={dialogTitle} message={dialogMessage} show={show} handleClose={() => setShow(false)} />
        <Header />
        <Category />
        <div style={{margin:"0 auto",width:"360px",boxSizing:"border-box",position:"fixed",zIndex:"1",top:(window.innerHeight - 500) / 2,left:(window.innerWidth - 360) / 2,display:postedGroupId !== "" ? "block" : "none"}}>
            <Alert style={{position:"absolute"}}>
                <CloseButton style={{position:"absolute",right:"20px"}} onClick={() => {
                    setPostedGroupId("")
                    setURL("")
                    setImgURL("")
                }}/>
                <p>投稿完了しました。<br />
                   SNSで共有してたくさんの人に見てもらいましょう！<br />
                   ※新着には10分程で反映されます。<br />
                   </p>
                <p><a href={url} target="_blank" rel="noreferrer" style={{textDecoration:"none",padding:"8px 14px",borderRadius:"20px",backgroundColor:"#000000",color:"#FFFFFF",border:"1px solid #1D9BF0"}}>𝕏 Post</a></p>
                <div style={{width:"360px",height:"360px"}}>
                    <Link to={"/event/"+postedGroupId}><Image src={imgUrl} style={{objectFit:"cover",width:"100%",height:"100%",borderRadius:"20px"}} /></Link>
                </div>
            </Alert>
        </div>
        <Container style={{display:postedGroupId !== "" ? "none" : "block"}}>
            <Tabs defaultActiveKey="event" className="mt-3"
            onSelect={(s) => {if(s !== "audio") navigate("/upload/"+s)}}>
                <Tab eventKey="model" title={<><Icon.Magic /> {t("common.model")}</>} style={{position:"relative",display:postedGroupId === "" ? "block" : "none"}} onClick={() => navigate("/upload/model")}></Tab>
                <Tab eventKey="character" title={<><Icon.Person /> {t("upload.character.title")}</>} style={{position:"relative",display:postedGroupId === "" ? "block" : "none"}} onClick={() => navigate("/upload/character")}></Tab>
                <Tab eventKey="image" title={<><Icon.Image /> {t("upload.image.title")}</>} style={{position:"relative",display:postedGroupId === "" ? "block" : "none"}} onClick={() => navigate("/upload/image")}></Tab>
                <Tab eventKey="video" title={<><Icon.FileText /> {t("upload.video.title")}</>} style={{position:"relative",display:postedGroupId === "" ? "block" : "none"}} onClick={() => navigate("/upload/video")}></Tab>
                <Tab eventKey="text" title={<><Icon.FileText /> {t("upload.text.title")}</>} style={{position:"relative",display:postedGroupId === "" ? "block" : "none"}} onClick={() => navigate("/upload/text")}></Tab>
                <Tab eventKey="audio" title={<><Icon.VolumeUp /> {t("upload.audio.title")}</>} style={{position:"relative",display:postedGroupId === "" ? "block" : "none"}} onClick={() => navigate("/upload/audio")}>
                    準備中・・・
                </Tab>
                <Tab eventKey="event" title={<><Icon.Shop /> {t("upload.event.title")}</>} style={{position:"relative",display:postedGroupId === "" ? "block" : "none"}} onClick={() => navigate("/upload/event")}></Tab>
            </Tabs>
            {false && odai ? <Link to={"/odai"} className='d-none d-md-block'><Alert variant='warning'>今日のお題「{odai}」</Alert></Link> : ""}
                    <pre style={{backgroundColor:"#555555",color:"#FFFFFF",padding:"10px",borderRadius:"5px",display:messageShow}}>{message}</pre>
                    <Accordion flush style={{border:"1px solid #CCCCCC"}} className="mb-3">
                        <Accordion.Item eventKey="0">
                            <Accordion.Header><Icon.LightbulbFill style={{color:"orange"}} />&nbsp;{t("upload.event.stepsToSubmission")}</Accordion.Header>
                                <Accordion.Body>
                                <ul style={{listStyle:"none"}} className="p-0">
                                    <li>{t("upload.event.step1-1")}</li>
                                    <li>{t("upload.event.step2")}</li>
                                    <li>{t("upload.event.step3")}</li>
                                    <li>{t("upload.event.step4")}</li>
                                </ul>
                                </Accordion.Body>
                        </Accordion.Item>
                    </Accordion>
                    <h3>①{t("upload.image.images")}</h3>
                    <Container className="d-block mb-3" style={{border:"3px solid #000000",borderRadius:"5px",minHeight:"100px",overflow:"auto",cursor:"pointer"}} id="upload-area"
                        onDragOver={(e) => e.preventDefault()}
                        onDrop={(e) => {
                            e.preventDefault()
                            if(fileList.length === 0){
                                imageSet(e.dataTransfer.files,setFileList)
                            } else {
                                if(dragElm === undefined){
                                    imageAdd(e.dataTransfer.files,fileList,setFileList)
                                }
                            }
                        }}
                        onDragEnd={() => setDragElm()}
                        onClick={(e) => {
                            e.stopPropagation()
                            if(fileList.length === 0){
                                document.getElementById("file").click()
                            } else {
                                document.getElementById("file_add").click()
                            }
                        }}
                        onDrag={(e) => {
                            if(dragElm){
                                let img = document.getElementById(dragElm)
                                let no = img.dataset.no
                                let imgClient = img.getBoundingClientRect()
                                let uploadClient = document.querySelector("#upload-area").getBoundingClientRect()
                                let bodyClient = document.querySelector("body").getBoundingClientRect()
                                // console.log(e.pageY,client.top,client.y,window.scrollY)
                                let x = e.pageX - window.scrollX
                                let y = e.pageY - window.scrollY
                                img.style.position = "fixed"
                                img.style.top = y - 75 +"px"
                                img.style.left = x - 75 + "px"
                                img.style.zIndex = "201"
                                //console.log(x,y,no)
                                let range = false
                                let l = len
                                let moreThan1 = false
                                fileList.forEach((elm,i) => {
                                    if(no === String(i)) return
                                    let targetImg = document.getElementById("imgDrag"+i)
                                    let client = targetImg.getBoundingClientRect()
                                    // 中心からの距離が一番近いもの？
                                    let targetX = client.x + (client.width / 2)
                                    let targetY = client.y + (client.height / 2)
                                    let lenX = Math.abs(x - targetX)
                                    let lenY = Math.abs(y - targetY)
                                    if(((l[1] >= lenX && l[2] >= lenY) || (lenX < 75 && lenY < 75)) || l[0] === -1){
                                        l = [i,lenX,lenY]
                                        //console.log(i,x,y,targetX,targetY,"近い要素："+l[0],lenX,lenY)
                                        moreThan1 = true
                                    }
                                })
                                setLen(l)
                                range = (l[1] < 75 && l[2] < 75) && l[0] !== -1 && moreThan1
                                setInRange(range)
                                setSelectingNo(no)
                                // console.log(x,y,img2.getBoundingClientRect())
                            }
                        }}
                        onDragEnter={(e) => {
                            //console.log("dragEnter",e)
                        }}
                        >
                        {fileList.map((imgFile,i) => {
                            if(imgFile.imageData !== undefined){
                                document.getElementById("img" + i).src = imgFile.imageData
                            } else {
                                ImageUtil.load(fileList,imgFile.file,i,(data,data2,data3)=>{
                                    if(data === false){
                                        imgFile.error = true
                                        setMessageShow("block")
                                        setMessage(message+"「"+imgFile.file.name+"」が読み込めませんでした。\r\n")
                                        // エラーなら削除
                                        setFileList(fileList.map(f=>f).filter((imgFile,idx)=>!imgFile.error))
                                    } else {
                                        document.getElementById("img"+i).src = data
                                        imgFile.imageData = data
                                        imgFile.imageDataMiddle = data2
                                        imgFile.imageDataOriginal = data3
                                        imgFile.imageDataEdited = data3
                                        // サムネイル調整用の初期画像
                                        if(i === editImageNo) {
                                            document.getElementById("load-image").src = fileList[editImageNo].imageDataEdited
                                        }
                                    }
                                })
                            }
                            return (
                                <div className="m-1" style={{float:"left",width:"150px",height:"150px",position:"relative"}} key={i} data-no={i} id={"imgDiv"+i}
                                onTouchStart={(e) => dragStart(e,i)}
                                onDragStart={(e) => dragStart(e,i)}
                                onDragEnd={(e) => {
                                    e.preventDefault()
                                    //console.log("dragEnd",len)
                                    let img = document.getElementById(dragElm)
                                    img.style.top = ""
                                    img.style.left = ""
                                    img.style.zIndex = "1"
                                    img.style.position = "relative"
                                    setLen([-1,0,0])
                                    let no = parseInt(e.currentTarget.dataset.no)

                                    if(inRange){
                                        // 挿入 no(選択中の要素)とlen[0]                                        
                                        let list = fileList.concat()
                                        if(no < len[0]){
                                            if(len[0] - no === 1){
                                                let tmp = list[no]
                                                list[no] = list[len[0]]
                                                list[len[0]] = tmp
                                                setFileList(list)
                                                setEditImageNo(len[0])
                                            } else {
                                                list.splice(len[0]+1,0,list[no])
                                                setFileList(list.filter((d,i) => i !== no))
                                                setEditImageNo(len[0])
                                            }
                                        } else if(no > len[0]){
                                            list.splice(len[0],0,list[no])
                                            setFileList(list.filter((d,i) => i !== no+1))
                                            setEditImageNo(len[0])
                                        }
                                        setSelectingNo(no)
                                        setDragElm("imgDrag"+len[0])
                                    } else {
                                        setDragElm()
                                        setSelectingNo(no)
                                    }
                                }}
                                onDrag={(e) => {
                                    //console.log("onDrag")
                                }}
                                >
                                    <div style={{width:"150px",height:"150px",position:"relative",backgroundColor:"#FFFFFF",
                                    marginLeft:inRange && len[0] === i ? (len[0] > selectingNo ? "-50px" : "50px") : "0px"}} id={"imgDrag"+i} data-no={i}>
                                        <Image className="upload-thumb" alt={imgFile.file.name} id={"img"+i} style={{objectFit:"contain",position:"absolute",width:"100%",height:"100%",cursor:"grab",
                                            border:editImageNo === i ? "6px solid orange" : "none"}} onClick={(e) => {
                                            e.stopPropagation()
                                            setEditImageNo(i)
                                        }}
                                        onDrag={(e) => {
                                            e.preventDefault()
                                        }}
                                        onDragEnd={(e) => {
                                            e.preventDefault()
                                        }}
                                        />
                                        <Icon.PencilFill style={{fontSize:"24px",position:"absolute",right:"40px",top:"10px",borderRadius:"20px",backgroundColor:"#FFFFFF",
                                            color:imgFile.useMosaic === "1" ? "#FF0000" : "blue"}} onClick={(e) => {
                                            e.stopPropagation()
                                            // 編集対象として設定
                                            setEditImageTargetNo(i)
                                        }} title="モザイクをかける" />
                                        <CloseButton style={{position:"absolute",right:"10px",top:"10px",borderRadius:"20px",backgroundColor:"#FFFFFF"}} onClick={(e) => {
                                            e.stopPropagation()
                                            // リストから画像削除
                                            setFileList(fileList.map(f=>f).filter((file,idx)=>i!==idx))
                                            if(editImageNo !== 0 && editImageNo >= i) setEditImageNo(editImageNo - 1)
                                        }} title="閉じる" />
                                        <Container style={{position:"absolute",bottom:"0",width:"100%",backgroundColor:"rgba(0,0,0,0.5)",color:"#FFFFFF",overflow:"hidden",whiteSpace:"nowrap"}}>{imgFile.file.name}</Container>
                                    </div>
                                </div>
                            )
                        })}
                        <Image id="dummy" src="/img/dot.png" style={{display:fileList.length > 0 ? "inline" : "none"}} />
                        {fileList.length === 0 ? (
                        <Container className="text-center p-3" style={{clear:"both",fontSize:"18px"}}>
                            <Icon.Upload style={{fontSize:"64px"}}/><br />
                            {t("upload.image.fileDragAndDrop")}<br />
                            {t("upload.image.paste")}<br />
                            <Button>{t("upload.image.selectFile")}</Button>
                        </Container>
                        ) : (
                        <div className="m-1 file-add" style={{float:"left",borderRadius:"10px",width:"150px",height:"150px",marginTop:"10px",position:"relative",border:"3px solid #555555"}}>
                            <Icon.PlusLg style={{fontSize:"48px",marginTop:"45px"}} className="w-100" />
                        </div>
                        )}
                    </Container>
                    <p><Icon.PencilFill style={{color:"#0000FF"}} /> マーククリックでモザイク編集できます。</p>
                    <Container id="crop-area">

                    </Container>
                    {showCropper ? (
                        <Container>
                    <Cropper
                        classes={{containerClassName: "cropper-container"}}
                        image={fileList.length > 0 && fileList[editImageNo].imageDataEdited}
                        crop={crop}
                        zoom={zoom}
                        aspect={cropTarget === "outside" ? 2 / 1 : 1 / 1}
                        onCropChange={setCrop}
                        onCropComplete={onCropComplete}
                        onZoomChange={setZoom}

                    />
                        <Container style={{position:"absolute",width:"300px",height:"110px",zIndex:3,left:window.innerWidth / 2 - 150,bottom:"120px",borderRadius:"10px",backgroundColor:"#EEEEEE"}} className="p-3">
                            <FloatingLabel controlId="crop-zoom" label="" className="mb-3"
                                style={{position:"absolute",zIndex:3,top:0,width:"90%",fontSize:"24px"}}
                            >
                                <Form.Range type="range" defaultValue={zoom} min={1} max={5} step={0.1} onChange={(e) => {
                                    setZoom(e.currentTarget.value)
                                }} />
                            </FloatingLabel>
                            <Button style={{position:"absolute",zIndex:3,left:"30px",bottom:"10px",fontSize:"24px"}} onClick={() => {
                                if(cropTarget === "inside"){
                                    setInsideThumbnail(tempThumbnail)
                                } else {
                                    setOutsideThumbnail(tempThumbnail)
                                }
                                setShowCropper(false)
                                
                            }}>OK</Button>
                            <Button variant='secondary' style={{position:"absolute",zIndex:3,right:"30px",bottom:"10px",fontSize:"24px"}} onClick={() => {
                                setShowCropper(false)
                            }}>Cancel</Button>
                            </Container>
                        </Container>
                    ) : ""}
                    <Container className='flex-wrap justify-content-center' style={{display:fileList.length > 0 ? "flex" : "none"}}>
                        <Container style={{border:"3px solid #000000",borderRadius:"5px",width:"250px",cursor:"pointer"}} className="p-2 text-center"
                            onClick={() => {
                                setShowCropper(true)
                                setCropTarget("inside")
                            }}
                        >

                            {t("common.thumbnail")} <Button variant='secondary'>{t("common.edit")}</Button><br />
                            <Container style={{width:"200px",height:"200px"}} className="p-0 mt-2">
                                {insideThumbnail === undefined ?
                                (<div style={{width:"200px",height:"200px",border:"1px solid #000000",paddingTop:"80px"}} >1:1</div>) : (
                                <Image id="crop-target-image" src={insideThumbnail} style={{objectFit:"cover",width:"100%",height:"100%",borderRadius:"10px"}} className="" />
                                )}
                            </Container>
                        </Container>
                        <Container style={{border:"3px solid #000000",borderRadius:"5px",width:"380px",height:"250px",cursor:"pointer"}} className="mt-3 p-2 text-center"
                            onClick={() => {
                                setShowCropper(true)
                                setCropTarget("outside")
                            }}
                        >

                            {t("common.thumbnailsForOutside")} <Button variant='secondary'>{t("common.edit")}</Button><br />
                            <Container style={{width:"360px",height:"180px"}} className="p-0 mt-2">
                                {outsideThumbnail === undefined ?
                                (<div style={{width:"360px",height:"180px",border:"1px solid #000000",paddingTop:"60px"}}>2:1</div>) : (
                                <Image id="crop-target-image-outside" src={outsideThumbnail} style={{objectFit:"cover",width:"100%",height:"100%",borderRadius:"10px"}} className="" />
                                )}
                            </Container>
                        </Container>
                    </Container>
                    {/* 読み込み用 */}
                    <Image id="load-image" className="d-none" />
                    {previewFlg ? (
                    <div style={{position:"fixed",top:0,left:0,width:"100%",height:"100%",zIndex:9999,cursor:"pointer"}} onClick={() => setPreviewFlg(false) }>
                        <div style={{position:"fixed",top:0,left:0,backgroundColor:"#000000",width:"100%",height:"100%",opacity:0.9}} />
                        <Image
                            src={previewSource}
                            id="preview"
                            style={{position:"fixed",objectFit:"contain",width:"100%",height:"100%"}}
                        />
                    </div>
                    ) : ""}
                    <Container style={{clear: "both"}} />
                    <Form style={{position:"relative"}}>
                    <Row>
                        <Col xs={12} sm={12} md={12} lg={12} xl={8} xxl={12} style={{display:fileList.length > 0 ? "block" : "none",margin:"0 auto",width:"100%"}}>
                            <Container>
                                {t("upload.image.fileCount")}：<span style={{color:fileList.length > 200 ? "#FF0000" : "#000000",fontWeight:fileList.length > 200 ? "bold" : "normal"}}>{fileList.length}</span> / 200 File(s)
                                <ProgressBar id="file-select-progress" animated now={Math.floor((fileList.length / 200) * 100)} label={`${Math.floor((fileList.length / 200) * 100)}%`} style={{marginBottom:"10px"}} />
                                {t("upload.image.fileSize")}：<span style={{color:fileSizeOver ? "#FF0000" : "#000000",fontWeight:fileSizeOver ? "bold" : "normal"}}>{fileSize}</span> / 20 GB
                                <ProgressBar id="filesize-progress" animated now={Math.floor(fileSizeByte / maxFileSize * 100)} label={`${Math.floor(fileSizeByte / maxFileSize * 100)}%`} style={{marginBottom:"10px"}} />
                            </Container>
                            {/*<p>拡張子：jpg、png、gif、webp</p>*/}
                            {/* .jpg,.jpe,.jpeg,.jfif,.png,.gif,.webp,.bmp */}
                            <Form.Control type="file" encType="multipart/form-data" accept="*.*" className='d-none' id="file" multiple onChange={(e) => {
                                imageSet(e.currentTarget.files,setFileList)
                                e.currentTarget.value = ""
                            }} />
                            <Form.Control type="file" encType="multipart/form-data" accept="*.*" className='d-none' id="file_add" multiple onChange={(e) => {
                                imageAdd(e.currentTarget.files,fileList,setFileList)
                                e.currentTarget.value = ""
                            }} />
                        </Col>
                    </Row>
                    <hr />
                    <Row>
                        <Col xs={12} sm={12} md={12} lg={8} xl={8} xxl={9} style={{margin:"0 auto"}}>
                            <h3>②{t("upload.image.info")}</h3>
                        </Col>
                        <Col xs={6} sm={7} md={6} lg={8} xl={8} xxl={9} style={{margin:"0 auto"}}>
                            {false && batchMode ? (
                            <InputGroup className="mb-3" style={{maxWidth:"360px"}}>
                                <InputGroup.Checkbox style={{cursor:"pointer",}} id="use_filename" onChange={(e) => {
                                        if(e.currentTarget.checked){
                                            setUseFilename(true)
                                            document.getElementById("title").setAttribute("disabled",e.currentTarget.checked)
                                            document.getElementById("title").value = "<ファイル名が設定されます>"
                                        } else {
                                            setUseFilename(false)
                                            document.getElementById("title").removeAttribute("disabled")
                                            document.getElementById("title").value = ""
                                        }
                                    }} />
                                <Form.Control type="text" style={{fontSize:"12px"}} defaultValue={"タイトルにファイル名を使用する"} readOnly />
                            </InputGroup>
                            ) : ""}
                        </Col>
                        <Col xs={12} sm={12} md={12} lg={12} xl={12} xxl={12} style={{margin:"0 auto"}}>
                            <Col xs={12} sm={12} md={12} lg={8} xl={8} xxl={9} style={{margin:"0 auto"}}>
                                <FloatingLabel controlId="title" label={<><span className='required'>必須</span> {t("upload.image.imageTitle")}</>} className="mb-3 w-100">
                                    <Form.Control type="text" placeholder="" required autoComplete="new-password" />
                                </FloatingLabel>
                            </Col>
                            <Col xs={12} sm={12} md={12} lg={8} xl={8} xxl={9} style={{margin:"0 auto"}}>
                                <FloatingLabel controlId="description" label={<><span className='required'>必須</span> {t("upload.image.imageDescription")}</>} className='mb-3 w-100'>
                                    <Form.Control
                                        as="textarea"
                                        style={{ height: '100px' }}
                                        required
                                        onChange={(e) => {
                                            setUseOdai(document.getElementById("description").value.indexOf("#"+odai) !== -1)
                                        }}
                                    />
                                </FloatingLabel>
                                {tagLatest.map(d => <Button variant='secondary' className='m-1 p-1' onClick={() => {
                                    document.querySelector("#description").value += " #" + d
                                }}>+{d}</Button>)}
                                <p>{t("upload.image.tag")}</p>
                                <span>タグ候補：</span>
                                {["同人誌即売会","技術カンファレンス","展示会","お品書き","セミナー"].map(d => {
                                    return <Button variant='warning' className='m-1' onClick={() => {
                                        let description = document.getElementById("description")
                                        if(description.value.length === 0){
                                            description.value = "#" + d
                                        } else {
                                            description.value += " #" + d
                                        }
                                    }}>「{d}」タグを追加</Button>
                                })}
                                <Typeahead id="tag" placeholder={t("category.tag")} clearButton={true} multiple
                                onInputChange={(input) => {
                                    tagSearch(input).then(r => {
                                        if(r.result){
                                            setTagOptions(r.data)
                                        }
                                    })
                                }}
                                onChange={(selected) => {
                                    setTag(selected)
                                }}
                                options={tagOptions}
                                />
                                <Typeahead id="place-div" className='mt-3' placeholder={"開催地域(複数選択可能)"} clearButton={true} multiple
                                onChange={(selected) => {
                                    setPlace(selected)
                                }}
                                options={placeOptions}
                                />
                            </Col>
                            <Col xs={12} sm={12} md={12} lg={8} xl={8} xxl={9} style={{margin:"0 auto"}}>
                                <FloatingLabel controlId="place" label={"開催場所詳細"} className="mt-3 mb-3 w-100">
                                    <Form.Control
                                        as="textarea"
                                        style={{ height: '100px' }}
                                        required
                                        onChange={(e) => {
                                            setUseOdai(document.getElementById("description").value.indexOf("#"+odai) !== -1)
                                        }}
                                    />
                                </FloatingLabel>
                            </Col>
                            <Col xs={12} sm={12} md={12} lg={8} xl={8} xxl={9} className='mb-3 mt-3' style={{margin:"0 auto"}}>
                                開催日
                                <div className='d-flex justify-content-center'>
                                    <FloatingLabel controlId="from-date" className='mb-3 w-100'>
                                        <Form.Control
                                            type="date"
                                            required
                                            defaultValue={fromDate}
                                            onChange={(e) => setFromDate(e.currentTarget.value)}
                                        />
                                    </FloatingLabel>
                                    <FloatingLabel controlId="from-time" className='mb-3 w-100'>
                                        <Form.Control
                                            type="time"
                                            required
                                            defaultValue={fromTime}
                                            onChange={(e) => setFromTime(e.currentTarget.value)}
                                        />
                                    </FloatingLabel>
                                    ～
                                    <FloatingLabel controlId="to-date" className='mb-3 w-100'>
                                        <Form.Control
                                            type="date"
                                            required
                                            defaultValue={toDate}
                                            onChange={(e) => setToDate(e.currentTarget.value)}
                                        />
                                    </FloatingLabel>
                                    <FloatingLabel controlId="to-time" className='mb-3 w-100'>
                                        <Form.Control
                                            type="time"
                                            required
                                            defaultValue={toTime}
                                            onChange={(e) => setToTime(e.currentTarget.value)}
                                        />
                                    </FloatingLabel>
                                </div>
                                <Button className="mb-3" onClick={() => {
                                    document.getElementById("from-date").value = ""
                                    document.getElementById("from-time").value = ""
                                    document.getElementById("to-date").value = ""
                                    document.getElementById("to-time").value = ""
                                    setFromDate("")
                                    setFromTime("")
                                    setToDate("")
                                    setToTime("")
                                }}>開催日の入力をクリア</Button>
                            </Col>
                            <Col xs={12} sm={12} md={12} lg={8} xl={8} xxl={9} style={{margin:"0 auto"}}>
                                <InputGroup className="mb-3">
                                    <InputGroup.Text>#</InputGroup.Text>
                                    <Form.Control
                                        id="event-tag"
                                        placeholder="イベント参加用タグ"
                                    />
                                </InputGroup>
                                開催期間中にイベント参加用タグをつけて利用者が関連作品を投稿すると、利用者にポイントが付与されます。<br /><br />
                            </Col>
                            <Col xs={12} sm={12} md={12} lg={8} xl={8} xxl={9} style={{margin:"0 auto"}}>
                                <FloatingLabel controlId="price" label={"料金"} className="mb-3 w-100">
                                    <Form.Control
                                        as="textarea"
                                        style={{ height: '100px' }}
                                        required
                                    />
                                </FloatingLabel>
                            </Col>
                            <Col xs={12} sm={12} md={12} lg={8} xl={8} xxl={9} style={{margin:"0 auto"}}>
                                <FloatingLabel controlId="access" label={"交通アクセス"} className="mb-3 w-100">
                                    <Form.Control
                                        as="textarea"
                                        style={{ height: '100px' }}
                                        required
                                    />
                                </FloatingLabel>
                            </Col>
                            <Col xs={12} sm={12} md={12} lg={8} xl={8} xxl={9} style={{margin:"0 auto"}}>
                                <FloatingLabel controlId="url" label={"公式サイト"} className="mb-3 w-100">
                                    <Form.Control type="text" placeholder="" required autoComplete="new-password" />
                                </FloatingLabel>
                            </Col>
                            <Col xs={12} sm={12} md={12} lg={8} xl={8} xxl={9} style={{margin:"0 auto"}}>
                                <FloatingLabel controlId="contact" label={"問い合わせ先"} className="mb-3 w-100">
                                    <Form.Control
                                        as="textarea"
                                        style={{ height: '100px' }}
                                        required
                                    />
                                </FloatingLabel>
                            </Col>
                            <Col xs={12} sm={12} md={12} lg={8} xl={8} xxl={9} className='mb-3 mt-3' style={{margin:"0 auto"}}>

                            </Col>
                            <Col xs={12} sm={12} md={12} lg={8} xl={8} xxl={9} style={{margin:"0 auto",display:"none"}}>
                                <Typeahead id="upload-option-select" placeholder={t("upload.image.option")}
                                    className="mb-3"
                                    multiple
                                    clearButton={true}
                                    onChange={(selected) => {
                                        setOptionSelected(selected)
                                    }}
                                    selected={optionSelected}
                                    defaultSelected={[]}
                                    options={[
                                        {label:t("upload.image.original"),value:"original"},
                                        {label:t("upload.image.limitedPublication"),value:"limitedPublication"},
                                        {label:t("upload.image.newPostHidden"),value:"newPostHidden"},
                                        {label:t("upload.image.rankingHidden"),value:"rankingHidden"}
                                    ]}
                                    />
                            </Col>
                            <Col xs={12} sm={12} md={12} lg={8} xl={8} xxl={9} style={{margin:"0 auto 10px auto",display:loginInfo.result !== undefined && loginInfo.result ? "block" : "none",display:"none"}}>
                                <Typeahead id="series-list" ref={ref} placeholder={"シリーズに追加"} clearButton={true}
                                onChange={(selected) => {
                                    let value = selected.length === 0 ? "" : selected[0]
                                    setSeries(value)
                                }}
                                options={seriesList}
                                />
                            </Col>
                            <Col xs={12} sm={12} md={12} lg={8} xl={8} xxl={9} style={{margin:"0 auto"}}>
                                <Typeahead id="upload-option-select" placeholder={t("upload.image.option")}
                                    className="mb-3"
                                    multiple
                                    clearButton={true}
                                    onChange={(selected) => {
                                        setOptionSelected(selected)
                                    }}
                                    selected={optionSelected}
                                    defaultSelected={[]}
                                    options={[
                                        {label:t("upload.image.limitedPublication"),value:"limitedPublication"},
                                    ]}
                                    />
                            </Col>
                        </Col>
                        <hr />
                        <Col xs={12} sm={12} md={12} lg={8} xl={8} xxl={9} style={{margin:"0 auto"}}>
                            <FloatingLabel controlId="request" label={t("upload.image.requestMessage")} className='mb-3 w-100' style={{display:"block"}}>
                                <Form.Control
                                    as="textarea"
                                    style={{ height: '100px' }}
                                    required
                                />
                            </FloatingLabel>
                            <Button variant="danger" style={{marginBottom:"10px"}} onClick={(e) => uploadHandler(e)} disabled={uploading}>{t("upload.image.upload")}</Button>
                            <Button variant="danger" style={{position:"fixed",zIndex:2,left:window ? (window.innerWidth - 200) / 2 : 0,bottom:"60px",width:"200px"}} onClick={(e) => uploadHandler(e)} disabled={uploading}>
                                {t("upload.image.upload")}
                                {uploading && (<><br /><ProgressBar className="progress" animated now={progressNow} label={`${progressLabel}`} /></>)}
                            </Button>
                            <div style={{marginBottom:"20px",cursor:"pointer",display:"inline"}} className='p-1'>
                                <div style={{border:"1px solid #555555",display:"inline"}} className="p-1"
                                    onClick={() => {
                                        dialog(t("common.scheduledPost"),
                                        <Container>
                                            <Container>
                                                <FloatingLabel controlId="booking-date" label={t("upload.image.bookingYmd")} className='mb-3 w-100'>
                                                    <Form.Control
                                                        type="date"
                                                        required
                                                        defaultValue={bookingDate}
                                                        onChange={(e) => setBookingDate(e.currentTarget.value)}
                                                    />
                                                </FloatingLabel>
                                            </Container>
                                            <Container>
                                                <FloatingLabel controlId="booking-time" label={t("upload.image.bookingHi")} className='mb-3 w-100'>
                                                    <Form.Control
                                                        type="time"
                                                        required
                                                        defaultValue={bookingTime}
                                                        onChange={(e) => setBookingTime(e.currentTarget.value)}
                                                    />
                                                </FloatingLabel>
                                                <Button className="mb-3" onClick={() => {
                                                    document.getElementById("booking-date").value = ""
                                                    document.getElementById("booking-time").value = ""
                                                    setBookingDate("")
                                                    setBookingTime("")
                                                }}>{t("upload.image.clearBooking")}</Button>
                                            </Container>
                                        </Container>
                                        )
                                    }}
                                >
                                    <Icon.Clock />
                                    {t("common.scheduledPost")}
                                </div>
                            </div>
                            <p>
                                <Link to='/terms'>利用規約</Link>に違反する投稿は削除の対象となります。
                            </p>
                            <p>
                                要望や不具合報告、その他アワートAIに関する更新情報の告知などは公式Discordでも行っています。<br />
                                <Icon.Discord /> <a href="https://discord.gg/vQNvaCXYvu" alt="Official Discord" target={"_blank"} rel="noreferrer">Official Discord</a>
                            </p>
                            {uploading && (<><ProgressBar className="progress" animated now={progressNow} label={`${progressLabel}`} style={{marginBottom:"10px"}} /></>)}
                            {uploading && batchUploading && (<><ProgressBar id="batch_progress" animated now={batchProgressNow} label={`${batchProgressLabel}`} style={{marginBottom:"10px"}} /></>)}
                        </Col>
                    </Row>
                    </Form>
        </Container>
        {postedGroupId === "" ? (<Footer />) : ""}
    </div>
    </>
    )
}

export default UploadEvent;
